import {toISODate, toDecimal, formatDateBr} from "../../utils/convert-fields"

export const mapEventosExtraordinariosToRows = (apiData = []) => {
    if (!apiData || apiData.length === 0) return [{}]

    return apiData.map(item => ({
        id: item.ID ?? `${Date.now()}-${Math.random()}`,
        _serverID: item.ID ?? null,
        dataReferencia: formatDateBr(item.DataReferencia),
        dataEvento: formatDateBr(item.DataEvento),
        dataLiquidacao: formatDateBr(item.DataLiquidacao),
        tipoEvento: item.TipoEvento || "",
        valorPercentual: item.ValorPercentual ?? "",
        valorFinanceiro: item.ValorFinanceiro ?? "",
        fonte: item.Fonte || "",
    }))
}

const DATA_FIELDS = [
    "dataReferencia", "dataEvento", "dataLiquidacao",
    "tipoEvento", "valorPercentual", "valorFinanceiro", "fonte",
]

export const mapSingleRowToPayload = (row = {}, cetip = "") => ({
    CETIP: cetip,
    DataReferencia: toISODate(row.dataReferencia),
    DataEvento: toISODate(row.dataEvento),
    DataLiquidacao: toISODate(row.dataLiquidacao),
    TipoEvento: row.tipoEvento || null,
    ValorPercentual: toDecimal(row.valorPercentual) ?? null,
    ValorFinanceiro: toDecimal(row.valorFinanceiro) ?? null,
    Fonte: row.fonte || null,
})

export const hasEventoData = (row) => {
    if (!row) return false
    return DATA_FIELDS.some(field => {
        const v = row[field]
        return v !== "" && v !== null && v !== undefined
    })
}

const REQUIRED_FIELDS = ["dataReferencia", "dataEvento", "dataLiquidacao", "tipoEvento"]

export const hasAllRequiredFields = (row) => {
    if (!row) return false
    return REQUIRED_FIELDS.every(field => {
        const v = row[field]
        return v !== "" && v !== null && v !== undefined && `${v}`.trim().length > 0
    })
}

export const isSameEventoRow = (rowA = {}, rowB = {}) =>
    !DATA_FIELDS.some(field =>
        `${rowA[field] || ""}`.trim() !== `${rowB[field] || ""}`.trim()
    )

export const extractSingleEventoFromResponse = (resp) => {
    const data = resp?.body ?? resp?.data ?? resp
    if (!data) return null
    if (Array.isArray(data)) return data[0]
    if (Array.isArray(data?.results)) return data.results[0]
    if (Array.isArray(data?.EventosExtraordinarios)) return data.EventosExtraordinarios[0]
    if (Array.isArray(data?.body)) return data.body[0]
    return data
}

export const mapRowsToEventosExtraordinariosPayload = (rows = [], cetip = "") => {
    return rows
        .filter(row => row && hasEventoData(row))
        .map(row => mapSingleRowToPayload(row, cetip))
}
